import { setLocation } from 'utils/wrappers';

const pricing = {
  initialize() {
    this.setEventListeners();
  },
  selectPlan() {
    const id = $(this).data('selected');
    const $selected = $(`.dropdown-item[data-planid="${id}"]`);
    const quantity = $selected.data('planquantity');
    const name = $selected.data('planname');
    const price = $selected.data('planprice');
    const interval = $selected.data('planinterval');

    if (price && quantity && id) {
      const planData = JSON.stringify({
        id, quantity, name, price, interval,
      });
      window.sessionStorage.setItem('epsubplan', planData);
      setLocation('/checkout/billing');
    }
  },
  updateSelected() {
    // update price
    $(this).parents('.tab-pane').find('.inline-cost .amount').text($(this).attr('data-planprice'));
    // update selected lookup amount
    $(this).parent().prev().text($(this).text());
    // add selection to button
    $(this).parents('.tab-pane').find('.get_started').data('selected', $(this).data('planid'));
  },
  setEventListeners() {
    $('.card-body').on('click', '.get_started', pricing.selectPlan);
    $('.card-body').on('click', '.dropdown-item', pricing.updateSelected);
  },
};

export default function () {
  // on load
  pricing.initialize();
}



// WEBPACK FOOTER //
// ./static-pages/pricing_plans.js